import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithGoogle } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        const params = new URLSearchParams(hash.replace('#', ''));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          console.error('No session_id found in URL');
          navigate('/login', { replace: true });
          return;
        }

        // Clear the URL fragment immediately
        window.history.replaceState(null, '', window.location.pathname);

        // Exchange session_id for user data via backend
        await loginWithGoogle(sessionId);
        
        // Check if there's a redirect URL stored from before OAuth
        const rawRedirect = sessionStorage.getItem('authRedirect');
        sessionStorage.removeItem('authRedirect');
        
        // Validate redirect is a safe relative path (starts with / but not //)
        const redirectUrl = rawRedirect && rawRedirect.startsWith('/') && !rawRedirect.startsWith('//') 
          ? rawRedirect 
          : '/dashboard';
        
        // Navigate to stored redirect or dashboard
        navigate(redirectUrl, { replace: true });
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login', { replace: true, state: { error: 'Authentication failed. Please try again.' } });
      }
    };

    processCallback();
  }, [location.hash, loginWithGoogle, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50">
      <div className="text-center">
        <div className="spinner mx-auto mb-4" />
        <p className="text-zinc-600">Completing sign in...</p>
      </div>
    </div>
  );
}
